export const CONTENT_SUBMISSION_ACTION = {
  SHARE: 'share',
  ACCEPT: 'accept',
  REJECT: 'reject',
  ARCHIVE: 'archive',
  UNARCHIVE: 'unarchive',
  COMMENT: 'comment',
  DOWNLOAD: 'download',
  VIEW_AI_ANALYSIS: 'viewAiAnalysis',
  RUN_AI_ANALYSIS: 'runAiAnalysis',
  RESIZE: 'resize',
} as const;

export type ContentSubmissionAction =
  (typeof CONTENT_SUBMISSION_ACTION)[keyof typeof CONTENT_SUBMISSION_ACTION];
